// extracted by mini-css-extract-plugin
export var collapsedSummary = "_pi-0";